import { type Path } from 'react-hook-form';

import { type RejectedProctorRequestEditionFormInput } from './schemas';

type PathOfRejectedProctorRequestEditionFormType = Path<RejectedProctorRequestEditionFormInput>;

export const REJECTED_PROCTOR_REQUEST_FORM_FIELD_NAME = {
  personal: {
    idNumber: 'personal.idNumber',
    titleTh: 'personal.titleTh',
    firstNameTh: 'personal.firstNameTh',
    lastNameTh: 'personal.lastNameTh',
    titleEn: 'personal.titleEn',
    firstNameEn: 'personal.firstNameEn',
    lastNameEn: 'personal.lastNameEn',
    email: 'personal.email',
    phoneNumber: 'personal.phoneNumber',
    address: 'personal.address',
  },
  employeeInfo: {
    code: 'employeeInfo.code',
    position: 'employeeInfo.position',
    department: 'employeeInfo.department',
    startedAt: 'employeeInfo.startedAt',
    termination: {
      isAssigned: 'employeeInfo.termination.isAssigned',
      endedAt: 'employeeInfo.termination.endedAt',
    },
  },
  document: {
    agreementForms: 'document.agreementForms',
    identifications: 'document.identifications',
  },
} as const satisfies {
  personal: Record<string, PathOfRejectedProctorRequestEditionFormType>;
  employeeInfo: Record<
    string,
    | PathOfRejectedProctorRequestEditionFormType
    | Record<string, PathOfRejectedProctorRequestEditionFormType>
  >;
  document: Record<string, PathOfRejectedProctorRequestEditionFormType>;
};
